import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/toolsReportActions'
import * as api from '../../../api/reports/general/toolsReport'

function* toolsReportGetEmployeesList(action) {
  try {
    const payload = yield call(api.getEmployeesList, action.filters)
    yield put({ type: constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* toolsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.TOOLS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TOOLS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchToolsReportGetEmployeesList() {
  yield takeLatest(constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.ACTION, toolsReportGetEmployeesList)
}

function* watchToolsReportGetFullReport() {
  yield takeLatest(constants.TOOLS_REPORT_GET_FULL_REPORT.ACTION, toolsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchToolsReportGetEmployeesList), fork(watchToolsReportGetFullReport)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/toolsReportSaga.js